import types from './types'

export default {
    [types.RESET]: state => {
        state.statusItem = void 0
        state.item = {}
    },
    [types.GET_ITEM.REQUEST]: (state) => {
        state.item = {}
        state.statusItem = 'fetching'
    },
    [types.GET_ITEM.SUCCESS]: (state, result) => {
        state.statusItem = 'success'
        state.item = result.data
    },
    [types.GET_ITEM.FAILURE]: state => {
        state.statusItem = 'failure'
    },
    [types.REMOVE_ITEM.REQUEST]: (state) => {
        state.item = {}
        state.statusItem = 'fetching'
    },
    [types.REMOVE_ITEM.SUCCESS]: (state, result) => {
        state.statusItem = 'success'
        state.item = result.data
    },
    [types.REMOVE_ITEM.FAILURE]: state => {
        state.statusItem = 'failure'
    },
    [types.CREATE_ITEM.REQUEST]: (state) => {
        state.item = {}
        state.statusItem = 'fetching'
    },
    [types.CREATE_ITEM.SUCCESS]: (state, result) => {
        state.statusItem = 'success'
        state.item = result.data
    },
    [types.CREATE_ITEM.FAILURE]: state => {
        state.statusItem = 'failure'
    },
    [types.UPDATE_ITEM.REQUEST]: (state) => {
        state.item = {}
        state.statusItem = 'fetching'
    },
    [types.UPDATE_ITEM.SUCCESS]: (state, result) => {
        state.statusItem = 'success'
        state.item = result.data
    },
    [types.UPDATE_ITEM.FAILURE]: state => {
        state.statusItem = 'failure'
    },
    [types.GET_USER.REQUEST]: (state) => {
        state.userStatus = 'fetching'
    },
    [types.GET_USER.SUCCESS]: (state, result) => {
        state.userStatus = 'success'
        state.users = result.data
    },
    [types.GET_USER.FAILURE]: state => {
        state.userStatus = 'failure'
    },
    [types.GET_TEAM.REQUEST]: (state) => {
        state.teamStatus = 'fetching'
    },
    [types.GET_TEAM.SUCCESS]: (state, result) => {
        state.teamStatus = 'success'
        state.teams = result.data
    },
    [types.GET_TEAM.FAILURE]: state => {
        state.teamStatus = 'failure'
    },
    [types.SET_COMPLETED.REQUEST]: (state) => {
        state.item = {}
        state.statusItem = 'fetching'
    },
    [types.SET_COMPLETED.SUCCESS]: (state, result) => {
        state.statusItem = 'success'
        state.item = result.data
    },
    [types.SET_COMPLETED.FAILURE]: state => {
        state.statusItem = 'failure'
    },
}
